var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('span',{staticClass:"counter-big-text"},[_vm._v(_vm._s(_vm.number)+" "+_vm._s(_vm.sufix))]),_c('span',{staticClass:"counter-description"},[_vm._v(_vm._s(_vm.description))])])}
var staticRenderFns = []

export { render, staticRenderFns }